import Skeleton from './Skeleton';

export default function PublicationOwnerSkeleton() {
  return (
    <div className="flex flex-col rounded-2xl bg-white px-4 py-5 md:px-8 dark:bg-slate-700">
      {/* Заголовок */}
      <Skeleton className="mb-4 h-6 w-40 rounded" />

      {/* Телефон */}
      <div className="mb-2 flex items-center">
        <Skeleton className="h-5 w-5 rounded-full" />
        <Skeleton className="ml-2 h-5 w-24 rounded" />
      </div>

      {/* Email */}
      <div className="mb-2 flex items-center">
        <Skeleton className="h-5 w-5 rounded-full" />
        <Skeleton className="ml-2 h-5 w-40 rounded" />
      </div>

      {/* Адрес */}
      <div className="flex items-center">
        <Skeleton className="h-5 w-5 rounded-full" />
        <Skeleton className="ml-2 h-5 w-56 rounded" />
      </div>
    </div>
  );
}
